import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { frameSpecifications, getDeliveryIndicatorConfig } from '../../../configuration'
import { excludeSkuFromProductUrls } from '../../../configuration/manifest'

const slots: Props['slots'] = {
  Configurator: RxGlassesConfiguratorGraphContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={frameSpecifications}
    />
  )
}

const getInitialProps = Page.getInitialProps
if (getInitialProps) {
  ProductDetailPage.getInitialProps = (ctx) =>
    getInitialProps({ ...ctx, pageConfig: { excludeSkuFromProductUrls } })
}

export default composePDP<Props>(ProductDetailPage)
